import styled from 'styled-components';

interface LayoutWrapperProps {
    isMenuOpen?: boolean;
}

export const LayoutWrapper = styled.section<LayoutWrapperProps>`
    height: 100%;
    display: grid;
    overflow: auto;
    grid-template-columns: auto auto 1fr;
    grid-template-rows: auto auto 2fr ;
    ${({ isMenuOpen }) => isMenuOpen
            && `
                &:before {
                  content: '';
                  position: fixed;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background-color: rgba(0, 0, 0, 0.5);
                  z-index: 10;
                  backdrop-filter: blur(4px);
                }
              `}
   
`;

export const MainHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px;
    border-bottom:1px solid #e8e8e8;
`;

export const Main = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    transition: .2s;
    background-color: #fafafa;

    grid-column-start: 2;
    grid-column-end: -1;
    grid-row-start: 2;
    grid-row-end: -1;

`;

export const PageHeadline = styled.div`
    grid-column: 2 / -1; 
`;

export const Container = styled.div`
    height: 100vh;
    width: 100%; 
    max-width: 1600px;
    margin: 0 auto; 
    position: relative; 
`;

export const AlertBlock = styled.div`
    position: absolute;
    right: 20px;
    bottom: 20px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    z-index: 100;
`;
